<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { TooltipDefinition } from 'carbon-components-svelte';

  import { shortAgo } from '../utils/relative-time';

  export let date: Date,
    align: 'start' | 'center' | 'end' = 'center';

  const SECOND_STEP = 5e3;
  const MINUTE = 6e4;
  const HOUR = 36e5;

  let now = Date.now(),
    timer: ReturnType<typeof setTimeout>,
    mounted = false;

  const scheduleUpdate = (target: Date) => {
    clearTimeout(timer);
    const diff = Date.now() - new Date(target).getTime();
    const step = diff < MINUTE ? SECOND_STEP : diff < HOUR ? MINUTE : 0;
    if (step > 0) {
      timer = setTimeout(() => {
        now = Date.now();
        scheduleUpdate(target);
      }, step - (diff % step));
    }
  };

  $: tooltipText = new Date(date).toLocaleString();
  $: shortAgoText = shortAgo(date, now);
  $: scheduleUpdate(date);

  onMount(() => {
    mounted = true;
  });
  onDestroy(() => clearTimeout(timer));
</script>

{#if shortAgoText}
  <TooltipDefinition {tooltipText} {align} portalTooltip>
    {#key shortAgoText}
      <span class="relative-date" in:fade={{ duration: mounted ? 200 : 0 }}>{shortAgoText}</span>
    {/key}
  </TooltipDefinition>
{:else}
  <span>—</span>
{/if}

<style>
  .relative-date {
    display: inline-block;
    white-space: nowrap;
  }
</style>
